import {Component, Input} from '@angular/core';
import {ActionMenuItem} from '../../models/action-menu-item.class';
import { NgClass } from '@angular/common';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-action-menu-item',
  templateUrl: './action-menu-item.component.html',
  styleUrls: ['./action-menu-item.component.scss'],
  imports: [NgClass, MatIcon, MatMenuTrigger, MatIconButton, MatMenu, MatMenuItem],
})
export class ActionMenuItemComponent {
  @Input() input: ActionMenuItem;
  @Input() small = false;
}
